import { Layout as AntdLayout } from 'antd';
import styled from 'styled-components';



export const StyledSidebar = styled(AntdLayout.Sider)`
  position: relative;
  overflow-y: auto;
  box-shadow: var(--shadow-medium);
  z-index: 998;
  margin-top: 70px;
  background: var(--color-primary);
  transition: all var(--transition-base);
  ${(props) =>
    props.collapsed
      ? `max-width: 76px !important;
    min-width: 76px !important;
    width: 76px !important;`
      : ``}
  ${(props: any) =>
    props.$isMobile
      ? props.collapsed
        ? `max-width: 0px !important;
    min-width: 0px !important;
    width: 0px !important;`
        : ``
      : props.collapsed
      ? `max-width: 76px !important;
    min-width: 76px !important;
    width: 76px !important;`
      : ``}

  & aside {
    display: none;
  }
  & .ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
    width: 76px;
  }
  & .ant-menu-dark {
    background: transparent;
  }
  & .ant-menu.ant-menu-dark .ant-menu-sub {
    background-color: transparent;
    box-shadow: none;
  }
  & .ant-menu.ant-menu-dark .ant-menu-item,
  .ant-menu-submenu {
    /* margin: 0; */
    padding-left: 30px !important;
    padding-right: 0;
    margin-bottom: 0px;
    margin-top: 1px;
  }
  & .ant-menu.ant-menu-dark .ant-menu-item-selected {
    background: var(--color-primary-hover);
    border-left: 4px solid var(--color-accent);
  }

  & .ant-menu.ant-menu-dark .ant-menu-item:hover {
    background: var(--color-primary-hover);
  }
  & .ant-menu-submenu-title {
    padding-left: 0px !important;
  }
  .ant-menu-item span,
  .ant-menu-submenu {
    color: #fff;
    font-weight: bold;
  }
` as any;

export const StyledSidebarHeader = styled(AntdLayout.Header)`
  position: relative;
  background: transparent;
  height: auto;
  text-align: center;
  margin-bottom: var(--space-6);
  padding: var(--space-4);

  & h1 {
    font-size: var(--text-2xl);
    line-height: var(--leading-tight);
    color: #fff;
    margin: 0;
    font-weight: var(--font-semibold);
  }
`;
